const createRedirectUri = (callbackPath = '/auth/callback') =>
  `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }${callbackPath}`

export default createRedirectUri



// WEBPACK FOOTER //
// ./src/Auth/createRedirectUri.js